import apiHub from "../services/apiHub";
import getHeadersHub from "../utils/returnHeadersHub";

export default class PackageRepository {
  searchAutoComplete = (data) => {
    const header = getHeadersHub();

    return apiHub.post(
      `/api/services/package-tour/auto-complete/`,
      data,
      header
    );
  };

  searchOrigins = (data) => {
    const header = getHeadersHub();
    return apiHub.post(`/api/services/package-tour/search/`, data, header);
  };

  searchDestinations = (data) => {
    const header = getHeadersHub();
    return apiHub.post(`/api/services/package-tour/search/`, data, header);
  };

  availablePackages = (data) => {
    const header = getHeadersHub();
    return apiHub.post(`/api/services/package-tour/search/`, data, header);
  };

  packageCheckRate = async (data) => {
    const header = getHeadersHub();
    return apiHub.post(`/api/services/package-tour/get/`, data, header);
  };

  packageBooking = async (data) => {
    const header = getHeadersHub();
    return apiHub.post(`/api/services/package-tour/booking/`, data, header);
  };

  getPackageDetails = async (bookingId) => {
    const header = getHeadersHub();
    return apiHub.get(
      `/api/services/package-tour/booking-details/${bookingId}`,
      header
    );
  };
}
